__webpack_require__.p = "/tarot/";